<template>
  <v-app light>
    <v-toolbar color="blue darken-2" fixed>
      <img :src="images.icon" />
      <v-spacer></v-spacer>
      <v-btn class="blue darken-2" dark medium depressed @click="onContact">
        <v-icon class="mx-2">fa-envelope</v-icon>
        Contact
      </v-btn>
    </v-toolbar>

    <v-content>
      <section v-if="screenHeight > 800 && screenWidth > 800">
        <v-container>
          <v-layout>
            <v-flex xs12 class="text-xs-center">
              <br />
              <img class="mt-5" :src="images.logo" />
            </v-flex>
          </v-layout>
        </v-container>
      </section>

      <v-divider class="divider"></v-divider>

      <section>
        <v-layout column wrap class="my-5" align-center>
          <v-flex s12 sm4 class="my-3">
            <div class="text-xs-center">
              <h2 class="headline">
                Right-fit network applications for your P4 network
                infrastructure
              </h2>
              <span class="subheading">
                Easily program the data plane elements of your P4 network in
                Python.
              </span>
            </div>
          </v-flex>
          <v-flex xs12>
            <v-container grid-list-ml>
              <v-layout row wrap align-center>
                <v-flex xs12 md4>
                  <v-card class="elevation-0 transparent">
                    <v-card-text class="text-xs-center">
                      <v-icon x-large class="blue--text text--darken-1"
                        >fa-bolt</v-icon
                      >
                    </v-card-text>
                    <v-card-title primary-title class="layout justify-center">
                      <div class="headline text-xs-center">
                        Lightweight Platform
                      </div>
                    </v-card-title>
                    <v-card-text>
                      Kyfour, an open-source software platform, has been
                      designed to be lightweight and easy-to-use. You can
                      leverage Python to develop production-grade P4 network
                      applications that can add value or solve a problem in your
                      network.
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex xs12 md4>
                  <v-card class="elevation-0 transparent">
                    <v-card-text class="text-xs-center">
                      <v-icon x-large class="blue--text text--darken-1"
                        >fa-project-diagram</v-icon
                      >
                    </v-card-text>
                    <v-card-title primary-title class="layout justify-center">
                      <div class="headline">
                        Ecosystem of Network Applications
                      </div>
                    </v-card-title>
                    <v-card-text>
                      An ecosystem of open-source P4 network applications that
                      provide common network functionalities will be developed.
                      You can leverage an existing network applications to use
                      in your network or customize it based on your network
                      requirements.
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex xs12 md4>
                  <v-card class="elevation-0 transparent">
                    <v-card-text class="text-xs-center">
                      <v-icon x-large class="blue--text text--darken-1"
                        >fa-shield-alt</v-icon
                      >
                    </v-card-text>
                    <v-card-title primary-title class="layout justify-center">
                      <div class="headline text-xs-center">
                        Cybersecurity Network Application
                      </div>
                    </v-card-title>
                    <v-card-text>
                      The first official open-source network application on
                      Kyfour will be a cybersecurity network application that
                      can drop denial of service attacks. This network
                      application will integrate with intrusion detection
                      systems.
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-container>
          </v-flex>
        </v-layout>
      </section>

      <section>
        <v-parallax :src="images.background" height="400">
          <v-layout column align-center justify-center>
            <div
              style="background-color: #051320"
              class="headline white--text mb-3 text-xs-center"
            >
              <b
                >Kyfour is an open-source lightweight P4 software platform for
                network service providers</b
              >
            </div>
            <div style="background-color: #051320">
              <b
                >With this product, network service providers can leverage novel
                or right-fit network applications to optimize or add value to
                network infrastructure services</b
              >
            </div>
            <v-btn class="blue darken-2 mt-5" dark large @click="onLearnMode">
              Learn more
            </v-btn>
          </v-layout>
        </v-parallax>
      </section>

      <section>
        <v-container grid-list-md>
          <v-layout row wrap>
            <v-flex xs12 text-xs-center class="mt-5">
              <div class="headline">Are you interested?</div>
              <br />
              <div>
                Kyfour and its ecosystem of network applications will launch 
                soon
              </div>
            </v-flex>
            <v-flex xs8 offset-xs2>
              <v-card class="elevation-0 transparent">
                <v-card-text>
                  <v-flex xs12 class="text-xs-center" v-if="!subscribed">
                    <v-btn
                      class="blue darken-2 mb-5"
                      dark
                      large
                      @click="onGetInTouch"
                      >Get in touch</v-btn
                    >
                  </v-flex>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </section>

      <v-divider class="divider2"></v-divider>

      <section>
        <v-container grid-list-xl>
          <v-layout row wrap justify-center class="my-5">
            <v-flex xs12 sm4>
              <v-card class="elevation-0 transparent">
                <v-card-title primary-title class="layout justify-center">
                  <div class="headline">Company</div>
                </v-card-title>
                <v-card-text>
                  Kyfour Network Applications is a WA-based company that envisions a
                  future where P4 network applications will become pivotal for
                  network service providers to optimize or add value to their
                  networks. As a company, it is the primary software contributor
                  for Kyfour and its ecosystem of network applications.
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex xs12 sm4 offset-sm1>
              <v-card class="elevation-0 transparent">
                <v-card-title primary-title class="layout justify-center">
                  <div class="headline">Join our team</div>
                </v-card-title>
                <v-card-text>
                  We are planning to hire Software Engineers, Marketing Analysts
                  and Account Executives. If you believe in a future where P4
                  network applications will be pivotal for network services
                  providers and would like to contribute to Kyfour and its
                  ecosystem of network applications, reach out to us.
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </section>

      <v-layout row justify-center>
        <v-dialog v-model="dialog" persistent max-width="490">
          <v-card>
            <v-card-title class="headline blue lighten-5">{{
              headline
            }}</v-card-title>
            <v-card-text>
              {{ diag_paragraph }} please send an email to <b>{{ email }}</b
              >
              <br />
              <br />
              Thank you,
              <br />
              <br />

              <em>Kyfour Network Applications team</em>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-2" dark @click="dialog = false"
                >OK</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </v-content>
  </v-app>
</template>

<script>
export default {
  name: "App",
  data: function () {
    return {
      diag_paragraph: "",
      email: "kyfour.napps@deflvl.com",
      headline: "Learn more",
      dialog: false,
      screenHeight: 0,
      screenWidth: 0,
      images: {
        logo: "/static/logo_md.png",
        icon: "/static/icon_xs.png",
        background: "/static/parallax_bg.jpg",
      },
      subscribed: false,
    };
  },
  methods: {
    onContact: function () {
      this.headline = "Contact";
      (this.diag_paragraph = "If you wish to contact our team, "),
        (this.email = "kyfour.contact@deflvl.com");
      this.dialog = true;
    },
    onLearnMode: function () {
      this.headline = "Learn more";
      (this.diag_paragraph =
        "Kyfour has not been launched publicly yet. If you wish to subscribe to future software development updates, "),
        (this.email = "kyfour.news@deflvl.com");
      this.dialog = true;
    },
    onGetInTouch: function () {
      this.headline = "Get in touch";
      (this.diag_paragraph =
        "If you are interested in this plaform and network applications, "),
        (this.email = "kyfour.napps@deflvl.com");
      this.dialog = true;
    },
    subscribe: function () {
      this.subscribed = !this.subscribed;
    },
  },
  mounted: function () {
    this.screenHeight = screen.height;
    this.screenWidth = screen.width;
  },
};
</script>

<style scoped>
.divider {
  margin: 5em;
  margin-top: 1em;
}
.divider2 {
  margin: 5em;
  margin-top: 2em;
  margin-bottom: 2em;
}
</style>



// WEBPACK FOOTER //
// src/App.vue